import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("td", { class: "sticky-table-header cursor-pointer group-heading no-border row-number--header" }, null, -1)
const _hoisted_2 = ["colspan"]
const _hoisted_3 = { class: "text-h6 text-weight-regular" }
const _hoisted_4 = { class: "text-caption text-grey-7" }
const _hoisted_5 = {
  key: 0,
  class: "sticky-table-header cursor-pointer"
}

import { useI18n } from 'vue-i18n'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTableHeader',
  props: {
    groupHeading: {},
    isCollapsed: { type: Boolean },
    rowsLength: {},
    columnLength: {}
  },
  emits: ["update:isCollapsed"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n({ useScope: 'global' })

const props = __props

const emit = __emit

const isCollapsed = useModelWrapper(props, emit, 'isCollapsed')

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: "bg-grey-1 text-grey-9 cursor-pointer table-header",
    onClick: toggleCollapsed,
    "data-test": "group-heading"
  }, [
    _hoisted_1,
    _createElementVNode("td", {
      align: "left",
      colspan: _ctx.columnLength,
      class: "cursor-pointer q-mt-sm sticky-table-header group-heading sticky--left cursor-pointer"
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.groupHeading), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(` ${_ctx.rowsLength} ${_unref(t)('data.item', _ctx.rowsLength)}`), 1)
    ], 8, _hoisted_2),
    (_ctx.$slots.itemRight)
      ? (_openBlock(), _createElementBlock("td", _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})